<template>
  <div class="mnp-in-summary container">
    <div class="container-box ">
      <div class="flex-justify-content-between">
        <h2 class="text-3xl">Zusammenfassung</h2>
        <button @click="back()" class="change-data-button text-sm">
          <img src="/files/lidl/images/new-icons/svg/pen-outline.svg" /><span>Angaben ändern</span>
        </button>
      </div>
      <div class="content-limiter">
        <div v-if="paymentInformation" class="data-grid text-base">
          <div class="col">
            <p class="label">Name des Anbieters</p>
            <p>{{ selectedKeys.providerKey }}</p>
          </div>
          <div class="col">
            <p class="label">Zu portierende Rufnummer</p>
            <p>{{ portationMsisdn }}</p>
          </div>
          <div class="col">
            <p class="label">Name im alten Vertrag</p>
            <p>{{ salutation(person.gender) }} {{ person.firstName }} {{ person.lastName }}</p>
          </div>
          <div class="col">
            <p class="label">Geburtstag im alten Vertrag</p>
            <p>{{ person.birthDate }}</p>
          </div>
          <div v-if="!isNoPayment" class="col">
            <p class="label">Deine aktuelle Zahlungsart</p>
            <p>{{ isCreditCard ? 'Kreditkarte' : 'Lastschrift' }}</p>
          </div>
          <div v-if="!isNoPayment" class="col">
            <p class="label">{{ isCreditCard ? 'Kreditkarteninhaber' : 'Kontoinhaber' }}</p>
            <p>{{ isCreditCard ? paymentInformation.paymentType.holder : paymentInformation.paymentType.owner }}</p>
          </div>
          <div v-if="isBankAccount && !isNoPayment" class="col">
            <p class="label">IBAN</p>
            <p class="flex-align-center">
              <span class="iban-number-block">****</span>
              <span class="iban-number-block">****</span>
              <span class="iban-number-block">****</span>
              <span>{{ paymentInformation.paymentType.iban }}</span>
            </p>
          </div>
          <div v-if="isCreditCard && !isNoPayment" class="col">
            <p class="label">Prüfnummern</p>
            <p class="flex-align-center">
              <span class="iban-number-block">****</span>
              <span class="iban-number-block">****</span>
              <span class="iban-number-block">****</span>
              <span>{{ paymentInformation.paymentType.lastDigits }}</span>
            </p>
          </div>
          <div v-if="isNoPayment" class="col">
            <p class="label">Deine aktuelle Zahlungsart</p>
            <p>Keine Zahlart hinterlegt</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-justify-content-between">
      <button class="button button--secondary" @click="back()">Zurück</button>
      <button class="button button--primary" @click="request()" :disabled="loading">Jetzt kostenlos beantragen</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'

import processSteps from '@/mixins/processSteps'
import { stepName as previousProcessStep } from './Data.vue'
import { stepName as nextProcessStep } from './Success.vue'

export const stepName = 'mnpInSummary'

export default {
  name: 'MnpInSummary',
  data() {
    return {
      loading: false,
      paymentInformation: {
        paymentType: {}
      }
    }
  },
  props: {},
  components: {},
  computed: {
    isNoPayment() {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    },
    ...mapGetters('mnpIn', ['person', 'selectedKeys', 'portationMsisdn'])
  },
  methods: {
    ...mapMutations('mnpIn', ['goToStep']),
    ...mapActions('mnpIn', ['performMnpIn']),

    salutation(gender) {
      switch (gender) {
        case 'MALE':
          return 'Herr'
        case 'FEMALE':
          return 'Frau'
      }
    },
    back() {
      this.goToStep(this.previousStep)
    },
    request() {
      this.loading = true
      this.performMnpIn({
        person: this.person,
        portationMsisdn: this.portationMsisdn,
        selectedKeys: this.selectedKeys,
        nextStep: this.nextStep
      }).then(
        () => {
          this.loading = false
        },
        () => {
          this.loading = false
        }
      )
    }
  },
  mixins: [slotProxy(), processSteps(stepName, previousProcessStep, nextProcessStep)],
  apollo: {
    paymentInformation: function() {
      return wrapQuery(
        gql`
          query changePayment {
            paymentInformation {
              paymentType {
                ... on BankAccount {
                  type
                  iban
                  owner
                }
                ... on CreditCard {
                  type
                  holder
                  company
                  expiryMonth
                  expiryYear
                  lastDigits
                }
              }
            }
          }
        `,
        this,
        'paymentInformation'
      )
    }
  }
}
</script>
